"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _snapsvg = require("snapsvg");

var _snapsvg2 = _interopRequireDefault(_snapsvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            state: "first",
            morphFirst: "M200 0C310.98 0 400 89.02 400 200V480C400 590.98 310.98 680 200 680C89.02 680 0 590.98 0 480V200C0 89.02 89.02 0 200 0Z",
            morphSecond: "M0 0H400V680H0V0Z"
        };
    },
    props: ['imageId', 'image', 'title', 'link'],
    methods: {
        mouseOver: function mouseOver(event) {
            this.state = "second";
            this.animate(event, this.morphSecond);
        },
        mouseLeave: function mouseLeave(event) {
            this.state = "first";
            this.animate(event, this.morphFirst);
        },
        animate: function animate(event, path) {
            (0, _snapsvg2.default)(event.target.nextElementSibling.childNodes[1].children[1]).stop().animate({
                'd': path
            }, 300, mina.linear);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"sector-shape\">\n    <a href=\"{{link}}\" title=\"{{title}}\" @mouseover=\"mouseOver\" @mouseout=\"mouseLeave\">{{title}}</a>\n    <div class=\"sector-shape__svg\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 680\">\n            <defs>\n                <pattern id=\"sector-shape--style-{{imageId}}\" x=\"0\" y=\"0\" width=\"400\" height=\"680\" patternUnits=\"userSpaceOnUse\">\n                    <image image-rendering=\"optimizeQuality\" preserveAspectRatio=\"none\" width=\"400\" height=\"680\" xlink:href=\"{{image}}\"></image>\n                </pattern>\n                <filter id=\"b\" width=\"1.1\" height=\"1.1\" x=\"-.05\" y=\"-.05\" color-interpolation-filters=\"sRGB\">\n                    <feFlood result=\"flood\" flood-color=\"#000\" flood-opacity=\".39\"></feFlood>\n                    <feComposite result=\"composite1\" operator=\"in\" in2=\"SourceGraphic\" in=\"flood\"></feComposite>\n                    <feGaussianBlur result=\"blur\" stdDeviation=\"6.8\" in=\"composite1\"></feGaussianBlur>\n                    <feOffset result=\"offset\" dy=\"6\" dx=\"-2.1\"></feOffset>\n                    <feComposite result=\"composite2\" in2=\"offset\" in=\"SourceGraphic\"></feComposite>\n                </filter>\n            </defs>\n            <path fill=\"url(#sector-shape--style-{{imageId}})\" d=\"M200 0C310.98 0 400 89.02 400 200V480C400 590.98 310.98 680 200 680C89.02 680 0 590.98 0 480V200C0 89.02 89.02 0 200 0Z\" filter=\"url(#b)\"></path>\n        </svg>\n    </div>\n    <h3 class=\"title title--h3\">{{title}}</h3>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-62b3aa99", module.exports)
  } else {
    hotAPI.update("_v-62b3aa99", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}